const actionTypeIdentifier = 'CD8B344D-8CB2-455E-A792-398792F2B535';

export const getDebitorCatalogue = `GET-DEBITOR-CATALOGUE-${actionTypeIdentifier}`;
export const setDebitorCatalogueError = `SET-DEBITOR-CATALOGUE-ERROR-${actionTypeIdentifier}`;
export const setDebitorCatalogueColSearchStr = `SET-DEBITOR-CATALOGUE-COLUMN-SEARCH-STR-${actionTypeIdentifier}`;
export const sortDebitorCatalogueItems = `SORT-DEBITOR-CATALOGUE-ITEMS-${actionTypeIdentifier}`;
export const setDebitorCataloguePageSize = `SET-DEBITOR-CATALOGUE-PAGE-SIZE-${actionTypeIdentifier}`;
export const setDebitorCatalogueFilter = `SET-DEBITOR-CATALOGUE-FILTER-${actionTypeIdentifier}`;
export const applyDebitorCatalogueFilter = `APPLY-DEBITOR-CATALOGUE-FILTER-${actionTypeIdentifier}`;
export const setDefaultDebitorCatalogue = `SET-DEFAULT-DEBITOR-CATALOGUE-${actionTypeIdentifier}`;
export const getDebitorCatalogueDropdownList = `GET-DEBITOR-CATALOGUE-DROPDOWN-LIST-${actionTypeIdentifier}`;
export const getDebitorDetailbyId = `GET-DEBITOR-DETAIL-BY-ID-${actionTypeIdentifier}`;
export const resetDebitorCatalogueForm = `RESET-DEBITOR-CATALOGUE-FORM-${actionTypeIdentifier}`;
export const setDebitorCountryList = `SET-DEBITOR-COUNTRY-LIST-${actionTypeIdentifier}`;
export const getDebitorCountryList = `GET-DEBITOR-COUNTRY-LIST-${actionTypeIdentifier}`;
export const getDebitorSalesOrganizationList = `GET-DEBITOR-SALES-ORG-LIST-${actionTypeIdentifier}`;

export const debitorCatalogueModel = {
    debitorId: 0,
    debitorNumber: "",
    debitorName: "",
    oeName: "",
    countryId: 0,
    currencyId: 0,
    salesOrganizationId: 0,
    salesOrganizationName: "",
    salesOrganizationCountryCode: "",
    vatPercent: "",
    vatGroupId: 0
}